export default "__VITE_ASSET__b8ee9a0d__"